import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["menu", "button", "icon"];

  connect() {
    // Close the dropdown if clicking outside
    this.clickOutsideHandler = this.hide.bind(this);
    document.addEventListener("click", this.clickOutsideHandler);
  }

  disconnect() {
    document.removeEventListener("click", this.clickOutsideHandler);
  }

  toggle(event) {
    event.stopPropagation();
    if (this.menuTarget.classList.contains("hidden")) {
      this.menuTarget.classList.remove("hidden");
      // Small delay to allow the element to be visible before starting the transition
      setTimeout(() => {
        this.menuTarget.classList.remove("opacity-0", "scale-95");
        this.menuTarget.classList.add("opacity-100", "scale-100");
      }, 10);
    } else {
      this.menuTarget.classList.add("opacity-0", "scale-95");
      this.menuTarget.classList.remove("opacity-100", "scale-100");
      // Wait for the transition to complete before hiding
      setTimeout(() => {
        this.menuTarget.classList.add("hidden");
      }, 150);
    }
    if (this.hasIconTarget) {
      this.iconTarget.classList.toggle("rotate-180");
    }
  }

  hide(event) {
    if (this.element.contains(event.target)) return;

    this.menuTarget.classList.add("opacity-0", "scale-95");
    this.menuTarget.classList.remove("opacity-100", "scale-100");
    // Wait for the transition to complete before hiding
    setTimeout(() => {
      this.menuTarget.classList.add("hidden");
    }, 150);
    if (this.hasIconTarget) {
      this.iconTarget.classList.remove("rotate-180");
    }
  }
}
